export default function COutput() {
  return <h2>C Output</h2>;
}
